module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./TimeBar.js"));
	}, "TimeBar");
}